module.exports = __webpack_public_path__ + "static/media/gamesWon_1000_5000.eba1a99a.png";